import { parsePassioFoodDetailFromRest } from "./parsePassioFoodDetailFromRest";
import { MACRO_FDC_NUTRIENT_IDS } from "@notemeal/nutrient-utils";
const MACRO_FDC_IDS = new Set(MACRO_FDC_NUTRIENT_IDS);
export const buildAddPassioFoodInput = (foodDetail, name, options) => {
    if (!foodDetail.refCode) {
        return null;
    }
    const selectedQuantity = foodDetail.amount.selectedQuantity || 1;
    const fdcAmounts = foodDetail.fdcNutrientAmounts ?? [];
    const findFdcAmount = (fdcId) => fdcAmounts.find(n => n.fdcNutrientId === fdcId)?.amount ?? 0;
    const cho = findFdcAmount(1005) / selectedQuantity;
    const pro = findFdcAmount(1003) / selectedQuantity;
    const fat = findFdcAmount(1004) / selectedQuantity;
    const kcal = findFdcAmount(1008) / selectedQuantity;
    // Exclude macros (already in cho/pro/fat/kcal) and normalize amounts to per-unit.
    const nutrientAmounts = fdcAmounts
        .filter(na => !MACRO_FDC_IDS.has(na.fdcNutrientId))
        .map(na => ({ fdcNutrientId: na.fdcNutrientId, amount: na.amount / selectedQuantity }));
    const servingUnits = foodDetail.amount.servingUnits ?? [];
    const selectedUnit = foodDetail.amount.selectedUnit || "serving";
    const additionalServings = servingUnits
        .filter((unit) => !!unit.unitName && unit.unitName !== selectedUnit && typeof unit.value === "number")
        .map(unit => ({
        units: { customUnits: unit.unitName, unitPrefix: null, unitSuffix: null, unitId: null },
        weight: unit.value,
        defaultAmount: 1,
    }));
    return {
        name,
        cho,
        pro,
        fat,
        kcal,
        defaultAmount: selectedQuantity,
        units: {
            customUnits: selectedUnit,
            unitPrefix: null,
            unitSuffix: null,
            unitId: null,
        },
        additionalServings,
        nutrientAmounts,
        thumbnailUrl: options?.thumbnailUrl ?? null,
        passioItemRefCode: foodDetail.refCode,
    };
};
export const buildAddPassioFoodInputFromRest = (raw, name, options) => {
    const detail = parsePassioFoodDetailFromRest(raw);
    if (!detail) {
        return null;
    }
    return buildAddPassioFoodInput(detail, name, { thumbnailUrl: options?.thumbnailUrl });
};
//# sourceMappingURL=buildAddPassioFoodInput.js.map